import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';

import { PfuStore } from '../stores/pfu.store';

export const PfuSummaryGuard: CanMatchFn = () => {
  const pfuStore = inject(PfuStore);
  const router = inject(Router);

  if (!pfuStore.loadingStatus().isLoaded) {
    return router.createUrlTree(['pfu', 'form']);
  }
  return true;
};
